
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/passwordless-mfa",
      function () {
        return require("private-next-pages/solutions/passwordless-mfa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/passwordless-mfa"])
      });
    }
  